import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, skip, tap } from 'rxjs';
import { WindowService } from '@app/shared/services';

@Component({
    selector: 'app-responsive-routing',
    templateUrl: './responsive-routing.component.html',
    styleUrls: ['./responsive-routing.component.scss'],
})
export class ResponsiveRoutingComponent implements OnInit, OnDestroy {
    protected readonly windowService = inject(WindowService);
    protected readonly router = inject(Router);

    protected readonly subscriptions$ = new Subscription();

    ngOnInit(): void {
        this.subscriptions$.add(
            this.windowService.lg$
                .pipe(
                    skip(1),
                    tap(() => {
                        this.router.navigateByUrl(this.router.url, { onSameUrlNavigation: 'reload' });
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
